import styled from "styled-components";
import { MapFiltersButton as MapFiltersButtonBase } from "../MapChrome/styled.js";

export { FiltersPanel as AppFilters } from "../MapChrome/styled.js";

// In the un-embedded view, App renders the School/State toggle above this
// map, adding ~91px of height that the button's default top offset (tuned
// for the embedded/iframe case, where that toggle is hidden) doesn't
// account for.
export const MapFiltersButton = styled(MapFiltersButtonBase)`
  @media (min-width: 640px) {
    [data-embedded="false"] & {
      top: 175px;
    }
  }
`;

export const StateMarker = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
  width: 40px;
  height: 40px;
  border-radius: 25px;
  color: #2B345F;
  text-align: center;
  font-family: var(--font-primary);
  transition: all 0.25s ease;

  &:hover {
    transform: scale(1.25);
  }

  background: ${(props) => props.color};
`;
